import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/Store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./views/authentication/auth/axios-interceptors";
import { UserProvider } from './views/authentication/auth/UserContext';
import UsersListProvider  from './context/UsersListProvider'; 
import "./index.css";
import "./custom.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <UserProvider>
      <UsersListProvider>
      <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}> 
          <ToastContainer />
          <App />
        </Suspense>
      </BrowserRouter>
      </UsersListProvider>
    </UserProvider>
  </Provider>
);
